export const importTypes = {
  owners: 'owners',
  personalAccounts: 'personalAccounts',
  personalAccountsByCompanies: 'personalAccountsByCompanies',
  individualMeters: 'individualMeters',
};
